import styled, { css } from 'styled-components';
import { space, color, layout, border } from 'styled-system';
import { getTextColor, themeGet, getPaletteColor } from '@magalu/stereo-ui-styles';
import { LogoMagalu } from '@magalu/stereo-ui-icons';
import Card from '../../atoms/Card';
import { ShippingList as ShippingListOrganism } from '../../organisms';
const magaluBorderTop = css`
  background-image: linear-gradient(
    to right,
    #fcd000 0,
    #ff8a00 17%,
    #ff253a 34%,
    #ff37a8 51%,
    #a400e1 67%,
    #0086ff 83%,
    #00d604 100%
  );
  background-size: 100% 6px;
  background-repeat: no-repeat;
  background-position: top;
`;
const titleStyle = css`
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  color: ${props => getTextColor('base')(props)};
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  max-width: 97%;
`;
const displayContainer = {
  vertical: css`
    display: block;
  `,
  horizontal: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    & > div {
      flex-basis: 30%;
    }
    & > button {
      flex-basis: 200px;
      flex-shrink: 0;
    }
  `
};
export const Display = styled(Card)`
  ${props => props.isMagalu && magaluBorderTop}
  background-color: ${props => getPaletteColor('background.lighter')(props)};
  padding: 1px 10px;
  margin: 0 2px 10px;
  border-radius: 6px;
  box-shadow: ${props => themeGet('elevations.5')(props)};
  ${({
  displayMode
}) => displayMode && displayContainer[displayMode]}
`;
export const Title = styled.h2`
  ${titleStyle}
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  font-weight: ${props => themeGet('fontWeights.medium')(props)};
  margin: 10px 12px;
`;
export const TitleDisplay = styled.div`
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  margin: 5px 5px 12px;
  & p {
    height: auto;
  }
`;
const contentContainer = {
  vertical: css`
    display: block;
  `,
  horizontal: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    & svg {
      ${props => props.isMagalu && css`
          width: 100px;
          height: auto;
        `}
    }
    & > div {
      ${({
    isMagalu
  }) => isMagalu && css`
          flex-grow: 1;
        `}
      flex-basis: 30%;
      flex-grow: 2;
    }
    & > button {
      flex-basis: 200px;
      flex-shrink: 0;
    }
  `
};
export const Content = styled.div`
  border-radius: 6px;
  & > div {
    margin: 8px 5px 12px;
  }
  ${({
  displayMode
}) => displayMode && contentContainer[displayMode]}
`;
export const Container = styled.div`
  border-radius: ${({
  exhibition
}) => exhibition === 'highlight' && '4px'};
  overflow: hidden;
  ${space}
  ${color}
  ${layout}
  ${border}
`;
export const LogoMagaluIcon = styled(LogoMagalu).attrs(props => ({
  color: getPaletteColor('base')(props),
  width: 80,
  height: 40,
  viewBox: '0 0 60 14'
}))`
  vertical-align: middle;
  margin-top: 10px;
  margin-left: 5px;
`;
const shippingContainer = {
  horizontal: css`
    & svg + p {
      margin-right: ${props => themeGet('fontSizes.1')(props)}px;
    }
  `
};
export const ShippingList = styled(ShippingListOrganism)`
  ${({
  displayMode
}) => displayMode && shippingContainer[displayMode]}
`;